import { render, staticRenderFns } from "./SalesDashboardReport.vue?vue&type=template&id=bbc3f088&scoped=true&"
import script from "./SalesDashboardReport.vue?vue&type=script&lang=js&"
export * from "./SalesDashboardReport.vue?vue&type=script&lang=js&"
import style0 from "./SalesDashboardReport.vue?vue&type=style&index=0&id=bbc3f088&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bbc3f088",
  null
  
)

export default component.exports